import { SinSidebarLayout } from 'layouts/SinSidebarLayout';
import imgAccessDenied from 'assets/images/ilustracion-access-denied.svg';
import Heading from 'components/design-system/Heading/Heading';
import Text from 'components/design-system/Text/Text';

export const MensajeSolicitarIniciarSesion = () => {
  return (
    <SinSidebarLayout containerClassName="xs:px-4 md:container md:mx-auto">
      <div className="bg-white rounded shadow-md p-4 sm:p-8 relative mb-16 text-center justify-center">
        <img
          src={imgAccessDenied}
          alt="Has aprobado la solicitud correctamente"
          className="mx-auto mb-6 h-40 md:h-80"
        />
        <Heading type="h2">Un momento</Heading>
        <Text size="M" className="mb-4 max-w-lg mx-auto">
          Para acceder a este contenido{' '}
          <strong className="text-black">debes haber iniciado sesión</strong>,
          presiona en la parte superior el botón{' '}
          <strong className="text-black">"Iniciar Sesión"</strong>.
        </Text>
      </div>
    </SinSidebarLayout>
  );
};
